<template>
  <!--加载进度-->
  <van-loading v-if="!isLoaded" class="loading" />
  <!--加载失败-->
  <div v-else-if="errorMessage" class="error-message">
    错误：{{ errorMessage }}
  </div>
  <!--业务类型选择器-->
  <div v-else>
    <van-tabs v-model="activeRightTypeIndex" class="business-type-tree-select-tabs">
      <van-tab v-for="rightType in rightTypes" :key="rightType.id">
        <div slot="title">
          <div class="van-tab__icon">
            <van-image
              width="48"
              height="48"
              fit="cover"
              :src="rightType.code|rightTypeIconSrc"
              class="icon"
            >
              <template v-slot:loading>
                <van-loading type="spinner" size="20" />
              </template>
            </van-image>
          </div>
          <div class="van-tab__label">
            {{ rightType.name }}
          </div>
        </div>
      </van-tab>
    </van-tabs>
    <van-tree-select
      height="100%"
      :items="treeSelectItems"
      :active-id.sync="activeBusinessTypeId"
      :main-active-index.sync="activeRegistrationTypeIndex"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import to from 'await-to-js'

export default {
  filters: {
    rightTypeIconSrc(code) {
      return process.env.BASE_URL + '/images/right-type/' + code + '.png'
    }
  },
  props: {
    businessTypeId: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      isLoaded: false,
      errorMessage: '',
      activeRightTypeIndex: 0,
      activeRegistrationTypeIndex: 0,
      activeBusinessTypeId: this.businessTypeId
    }
  },
  computed: {
    ...mapGetters(['rightTypes', 'registrationTypes', 'businessTypes']),
    activeRightTypeId() {
      if (this.rightTypes.length === 0) {
        return null
      } else {
        return this.rightTypes[this.activeRightTypeIndex].id
      }
    },
    activeBusinessType() {
      return this.businessTypes.find(
        businessType => businessType.id === this.activeBusinessTypeId
      )
    },
    treeSelectItems() {
      return this.registrationTypes.map(registrationType => {
        const children = this.filterBusinessTypes(
          this.activeRightTypeId,
          registrationType.id
        ).map(businessType => {
          return {
            text: businessType.alias,
            id: businessType.id,
            data: businessType
          }
        })
        if (children.length === 0) {
          children.push({ text: '暂无该类业务', disabled: true })
        }
        return {
          text: registrationType.name,
          children: children
        }
      })
    }
  },
  watch: {
    activeBusinessTypeId: function(newValue) {
      this.$emit('change', this.activeBusinessType)
    }
  },
  created() {
    // 加载数据
    this.loadData()
  },
  methods: {
    // 加载数据
    async loadData() {
      if (this.businessTypes.length === 0) {
        const [error] = await to(
          this.$store.dispatch('application/getBusinessTypes')
        )
        if (error) {
          // 设置错误信息
          this.errorMessage = error.message
        }
      }
      // 选择默认业务类型
      if (this.businessTypeId) {
        this.selectDefaultBusinessType()
      }
      // 设置加载状态为已加载
      this.isLoaded = true
    },
    // 过滤业务类型
    filterBusinessTypes(rightTypeId, registrationTypeId) {
      let filteredBusinessTypes = this.businessTypes
      if (rightTypeId) {
        filteredBusinessTypes = filteredBusinessTypes.filter(
          businessType => businessType.rightTypeId === rightTypeId
        )
      }
      if (registrationTypeId) {
        filteredBusinessTypes = filteredBusinessTypes.filter(
          businessType => businessType.registrationTypeId === registrationTypeId
        )
      }
      return filteredBusinessTypes
    },
    // 选择默认业务类型
    selectDefaultBusinessType() {
      const defaultSelectedBusinessType = this.businessTypes.find(
        businessType => businessType.id === this.businessTypeId
      )
      if (defaultSelectedBusinessType) {
        this.activeRightTypeIndex = this.rightTypes.findIndex(
          rightType => rightType.id === defaultSelectedBusinessType.rightTypeId
        )
        this.activeRegistrationTypeIndex = this.registrationTypes.findIndex(
          registrationType =>
            registrationType.id ===
            defaultSelectedBusinessType.registrationTypeId
        )
        this.activeBusinessTypeId = defaultSelectedBusinessType.id
      }
    }
  }
}
</script>

<style lang="scss">
.business-type-tree-select-tabs {
  .van-tabs__wrap {
    height: 64px;
    .van-tab {
      .van-tab__icon {
        width: 48px;
        height: 48px;
        margin: 0 auto;
      }
      .van-tab__label {
        height: 22px;
        line-height: 22px;
        margin-top: -10px;
      }
    }
  }
}
</style>

<style scoped lang="scss">
.loading {
  padding-top: 15px;
  text-align: center;
}
.error-message {
  color: #ee0a24;
  padding-top: 15px;
  text-align: center;
}
.van-tree-select {
  .van-tree-select__nav {
    width: 86px;
    min-width: 86px;
    max-width: 86px;
    flex-grow: 0;
    .van-tree-select__nav-item {
      padding: 12px;
    }
  }
  .van-tree-select__content {
    flex-grow: 1;
    .van-tree-select__item {
      padding: 12px 32px 12px 16px;
      line-height: normal;
      white-space: normal;
    }
  }
}
</style>
